import { useCallback } from "react";
import { mutateCache, useApi } from "./api";
import { NOTIFICATIONS_URL } from "./useNotifications";
import { InviteCalculationData } from "./types/calculationSharingInvites";

export const useCalculationInvitesApi = () => {
  const api = useApi();

  const refuseSharingInvite = useCallback(
    async (token: string): Promise<void> => {
      await api.postNoResult(`/invites/calculation_invites/refuse`, { token });
      mutateCache([`/calculations`, NOTIFICATIONS_URL]);
    },
    [api],
  );

  const getCalculationData = useCallback(
    async (token: string): Promise<InviteCalculationData> => {
      const encodedToken = encodeURIComponent(token);
      const url = `/invites/calculation_invites/${encodedToken}/calculation_data`;
      return api.get<InviteCalculationData>({ url, signal: new AbortController().signal });
    },
    [api],
  );

  return {
    refuseSharingInvite,
    getCalculationData,
  };
};
